import type { FC } from "react";

import { SkeletonBlock } from "@/components/podkit/loading/Skeleton";
import { AutomationsPageHeader } from "@/routes/automations/AutomationsPageHeader";

const statCardSkeletonClassName = "bg-surface-secondary rounded-xl border border-border-base p-4";

export const AutomationsPageSkeleton: FC = () => {
    return (
        <div
            data-testid="automations-page-skeleton"
            className="relative flex h-full min-w-0 grow flex-col overflow-y-auto"
        >
            <div className="sticky top-0 z-20 min-w-0 bg-surface-01 px-6 pb-6 pt-6">
                <AutomationsPageHeader
                    actions={
                        <div className="flex items-center gap-2">
                            <SkeletonBlock ready={false} className="hidden h-9 w-28 rounded-lg sm:block" />
                            <SkeletonBlock ready={false} className="h-9 w-16 rounded-lg" />
                        </div>
                    }
                />
            </div>

            <div className="flex min-w-0 flex-1 items-start gap-6 px-6 pb-6">
                <div className="flex min-w-0 flex-1 flex-col gap-6">
                    <div className="grid min-w-0 grid-cols-2 gap-2 sm:grid-cols-3">
                        <div className={statCardSkeletonClassName}>
                            <SkeletonBlock ready={false} className="mb-3 h-4 w-24" />
                            <SkeletonBlock ready={false} className="h-8 w-28" />
                        </div>
                        <div className={statCardSkeletonClassName}>
                            <SkeletonBlock ready={false} className="mb-3 h-4 w-28" />
                            <SkeletonBlock ready={false} className="h-8 w-24" />
                        </div>
                        <div className={`${statCardSkeletonClassName} col-span-2 sm:col-span-1`}>
                            <SkeletonBlock ready={false} className="mb-3 h-4 w-20" />
                            <SkeletonBlock ready={false} className="h-8 w-16" />
                        </div>
                    </div>

                    <div className="flex min-w-0 flex-col gap-3 @[700px]:flex-row @[700px]:items-center">
                        <SkeletonBlock ready={false} className="h-8 w-full flex-1 rounded-lg" />

                        <div className="grid min-w-0 grid-cols-2 gap-3 @[700px]:flex @[700px]:shrink-0">
                            <SkeletonBlock ready={false} className="h-8 w-full rounded-lg" />
                            <SkeletonBlock ready={false} className="h-8 w-full rounded-lg" />
                            <SkeletonBlock
                                ready={false}
                                className="col-span-2 h-8 w-full rounded-lg @[700px]:col-span-1"
                            />
                        </div>
                    </div>


                </div>

                <div className="hidden w-80 shrink-0 rounded-xl border border-border-subtle xl:block">
                    <div className="flex flex-col gap-3 p-4">
                        <SkeletonBlock ready={false} className="h-5 w-40" />
                        <SkeletonBlock ready={false} className="h-4 w-52" />

                        {Array.from({ length: 6 }).map((_, index) => (
                            <div key={index} className="rounded-xl border border-border-base p-4">
                                <SkeletonBlock ready={false} className="mb-3 h-4 w-full" />
                                <SkeletonBlock ready={false} className="h-4 w-4/5" />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
